import FavoritesItem from "./FavoritesItem";

export default FavoritesItem;
